import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { NotificationEmptyComponent } from '@next/core-lib/components';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
  DialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

import { CowDetailsComponent } from '../cow-details/cow-details.component';

export interface DrillCowListDialogInputData extends AbstractDialogData {
  cows: { internationalCowId: string; emphasize: boolean }[];
}

@Component({
  selector: 'app-drill-cow-list',
  templateUrl: './drill-cow-list.component.html',
  styleUrls: ['./drill-cow-list-component.scss'],
  imports: [
    DialogComponent,
    MatSlideToggle,
    FormsModule,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatButton,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NotificationEmptyComponent,
    CowDetailsComponent,
    TranslatePipe,
  ],
})
export class DrillCowListComponent extends AbstractDialog implements OnInit {
  protected mdDialogRef =
    inject<MatDialogRef<AbstractDialog, AbstractDialogResultData>>(MatDialogRef);
  data = inject<DrillCowListDialogInputData>(MAT_DIALOG_DATA);
  private readonly localeService = inject(LocaleService);

  public showAllCows = false;
  public columns: { id: string; label: string; type: 'link' }[] = [
    {
      id: 'internationalCowId',
      label: this.localeService.translate('shared.drill-cow-list.international-cow-id-column'),
      type: 'link',
    },
  ];

  public dataSource = new MatTableDataSource<DrillCowList>();
  public internationalCowId: string;

  ngOnInit(): void {
    this.setDataSource();
  }

  public columnIds = (): string[] => this.columns.map((item) => item.id);
  public hasData = (): boolean => this.data.cows.length > 0;

  public openCowDetails(internationalCowId: string): void {
    this.internationalCowId = internationalCowId;
  }

  public showAllCowsChange(event: MatSlideToggleChange): void {
    this.showAllCows = event.checked;
    this.setDataSource();
  }

  private setDataSource(): void {
    this.dataSource.data = [...this.data.cows]
      .sort()
      .filter((item) => (this.showAllCows === true ? true : item.emphasize === true))
      .map((item) => ({ internationalCowId: item.internationalCowId, emphasize: item.emphasize }));
    if (this.dataSource.data.length > 0) {
      this.internationalCowId = this.dataSource.data[0].internationalCowId;
    }
  }
}

export interface DrillCowList {
  internationalCowId: string;
  emphasize: boolean;
}
